import { MGPOptional } from '@everyboard/lib';
import { BooleanConfig } from '../../../config/BooleanConfig';
import { NumberConfig } from '../../../config/NumberConfig';
import { RulesConfigDescription } from '../../../config/RulesConfigDescription';
import { RulesConfigDescriptionLocalizable } from '../../../config/RulesConfigDescriptionLocalizable';
import { MGPValidators } from '../../../utils/MGPValidator';
import { AbstractRectangularGoRules } from '../abstract-rectangular-go/AbstractRectangularGoRules';
export class GoRules extends AbstractRectangularGoRules {
    static singleton = MGPOptional.empty();
    static RULES_CONFIG_DESCRIPTION = new RulesConfigDescription({
        name: () => $localize `19 x 19`,
        config: {
            width: new NumberConfig(19, RulesConfigDescriptionLocalizable.WIDTH, MGPValidators.range(1, 99)),
            height: new NumberConfig(19, RulesConfigDescriptionLocalizable.HEIGHT, MGPValidators.range(1, 99)),
            handicap: new NumberConfig(0, () => $localize `Handicap`, MGPValidators.range(0, 9)),
            zoom: new NumberConfig(1, () => $localize `Zoom`, MGPValidators.range(1, 5)),
            showZooms: new BooleanConfig(false, () => $localize `Show zooms`),
        },
    }, [{
            name: () => $localize `13 x 13`,
            config: {
                width: 13,
                height: 13,
                handicap: 0,
                zoom: 1,
                showZooms: false,
            },
        }, {
            name: () => $localize `9 x 9`,
            config: {
                width: 9,
                height: 9,
                handicap: 0,
                zoom: 1,
                showZooms: false,
            },
        }]);
    static get() {
        if (GoRules.singleton.isAbsent()) {
            GoRules.singleton = MGPOptional.of(new GoRules());
        }
        return GoRules.singleton.get();
    }
    constructor() {
        super(true);
    }
    getRulesConfigDescription() {
        return GoRules.RULES_CONFIG_DESCRIPTION;
    }
}
